import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, onBack, className = "" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  return (
    <div
      className={`bg-gradient-to-l from-primary-navy to-[#222ab5] text-white py-4 px-3 sm:px-4 md:px-6 shadow-lg ${className}`}
    >
      <div className="max-w-full mx-auto flex items-center justify-center relative">
        <button
          onClick={handleBack}
          className="absolute left-0 flex items-center gap-2 text-blue-100 hover:text-white transition-all font-quicksand group"
        >
          <div className="flex items-center gap-2 bg-[#181e87] hover:bg-[#0f146f] text-white px-3 py-2 rounded-lg transition-colors">
            <FaArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span className="hidden sm:inline">Back</span>
          </div>
        </button>

        <div className="text-center flex items-center gap-3 px-4">
          <h1 className="text-xl sm:text-2xl font-bold font-poppins">
            {title}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
